import {
  ContentSection,
  PageWrap,
  SectionHeading,
  ItemTeaser,
  Layout,
  Heading
} from '@vwfs-bronson/bronson-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { JOURNEY_STATE, useApplicationState } from '../../App.state';
import { adobeDataLayer } from '../../lib/adobe-analytics-data-layer/AdobeDataLayer';
import { CustomerHappiness } from '../../components/CustomerHappinessIndex';
import { SECTION_HEADING_ID } from '../../utils/conts';

export function Confirmation(): JSX.Element {
  const { t } = useTranslation('confirmation');
  const { state, dispatch } = useApplicationState();

  useEffect(() => {
    adobeDataLayer.pageViewConfirmationPage();
  }, []);

  useEffect(() => {
    dispatch({ type: 'updateJourneyStatus', journeyStatus: JOURNEY_STATE.CONFIRMATION });
  }, []);

  return (
    <>
      <ContentSection>
        <PageWrap>
          <div className="u-text-center">
            <i className="c-icon c-icon--xxlarge c-icon--[semantic-success] u-text-success" />
          </div>
        </PageWrap>
      </ContentSection>

      <ContentSection>
        <PageWrap size="small">
          <div className="u-text-center">
            <SectionHeading id={SECTION_HEADING_ID} tabIndex={0} level={1}>
              {t('title')}
            </SectionHeading>
            <p>{t('main-content')}</p>
          </div>
        </PageWrap>
      </ContentSection>

      <ContentSection>
        <PageWrap size="small">
          <Layout center>
            <Layout.Item default="1/2" xs="1/1">
              <ItemTeaser
                inline
                icon="semantic-dealer"
                title={t('contact-section.title')}
                headingLevel={5}
                className="u-text-center"
                style={{
                  justifyContent: 'center'
                }}
              >
                <Heading level={6}>{state.dealer?.name}</Heading>
                <div>{`${state.dealer?.street} ${state.dealer?.houseNumber}`}</div>
                <div>{`${state.dealer?.zip} ${state.dealer?.city}`}</div>
                <div>{state.dealer?.phone}</div>
              </ItemTeaser>
            </Layout.Item>
          </Layout>
        </PageWrap>
      </ContentSection>

      <CustomerHappiness />
    </>
  );
}
